/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Potentialmartinuselementaryschoolname4Inputs */



/**

* @param {_Field_Potentialmartinuselementaryschoolname4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_potentialmartinuselementaryschoolname4 = /** @type {((inputs?: _Field_Potentialmartinuselementaryschoolname4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Potentialmartinuselementaryschoolname4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Name der anderen Schule")
});
export { _field_potentialmartinuselementaryschoolname4 as "_field_potentialMartinusElementarySchoolName" }